import router from '@/router'

const defaultRouteForRole = {
  user: "PropertyList",
  superadmin: "PropertyList",
  admin: "AdminUserList"
}

export const unauthorizedInterceptor = error => {
  if (error.response.status === 401) {
    router.push({ name: defaultRouteForRole[localStorage.userRole] })
  }
  return Promise.reject(error)
}

export const apiPath = process.env.VUE_APP_API

export const getApiPath = (relative_path) => `${apiPath}${relative_path}`
